import { HTMLAttributes, ReactNode } from "react";

export type DraggableItem = {
    /** ID prvku, unikátní v rámci stromu. */
    readonly id: string;
    /** Učuje stav, zdali se pod prvkem mají zobrazit jeho potomci. */
    readonly expanded: boolean;
    /** Seznam ID-ček potomků a jejich pořadí. */
    readonly children: readonly string[];
};

export type ItemRendererType = (htmlElementProps: HTMLAttributes<HTMLElement>, item: DraggableItem, dragOverPosition: DragOverPosition | null) => ReactNode;

/** Typ popisující pozici kurzoru nad komponentou v době provolání události DragOver. */
export type DragOverPosition = "Top" | "Middle" | "Bottom";
